/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_How_2Inputs */

const en_coaching_how_2 = /** @type {(inputs: Coaching_How_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a time in the Cal.com scheduler that opens.`)
};

const id_coaching_how_2 = /** @type {(inputs: Coaching_How_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih waktu di penjadwal Cal.com yang terbuka.`)
};

/**
* | output |
* | --- |
* | "Pick a time in the Cal.com scheduler that opens." |
*
* @param {Coaching_How_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_how_2 = /** @type {((inputs?: Coaching_How_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_How_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_how_2(inputs)
	return en_coaching_how_2(inputs)
});